export default "__VITE_ASSET__CM$DoZEt__"